import React from 'react'
import {NavLink} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import "./NavButtonStyles.css";

class NavButton extends React.Component {
 
    render() {
        return <NavLink to={this.props.path} className="nav_link">
            <Button className="nav_link" onClick={this.props.callback}>
            {this.props.name}
            </Button>
        </NavLink> 
    }
}

export default NavButton
